import { bdrCalendarsApiConnector } from 'apiConnector/bdr-calendar';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, mergeMap, timeoutWith } from 'rxjs/operators';
import {
  bdrMonthlyExpiryDatesFailed,
  bdrMonthlyExpiryDatesReceived,
  bdrMonthlyExpiryDatesTimeout,
  MONTHLY_EXPIRY_DATES_REQUESTED,
} from 'state/monthlyExpiryDates/monthlyExpiryDates.action';
import type { BdrMonthlyExpiryDatesState } from 'state/monthlyExpiryDates/monthlyExpiryDates.model';
import type { EpicWithThunk } from 'state/state.common';

export interface FetchMonthlyExpiryCalendarsDatesEpicApi {
  getMonthlyExpiryCalendarsDates(calendarCodes: string[]): Observable<BdrMonthlyExpiryDatesState>;
}

export function fetchMonthlyExpiryCalendarsDatesEpic(
  timeoutInMillis = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType(MONTHLY_EXPIRY_DATES_REQUESTED),
      mergeMap(({ calendarCodes }) => {
        return bdrCalendarsApiConnector(httpClient)
          .getMonthlyExpiryCalendarsDates(calendarCodes)
          .pipe(
            map(calendars => bdrMonthlyExpiryDatesReceived(calendars)),
            catchError(_ => of(bdrMonthlyExpiryDatesFailed())),
            timeoutWith(timeoutInMillis, of(bdrMonthlyExpiryDatesTimeout()), appScheduler),
          );
      }),
    );
}
